export * from "./create-admin.component";
export * from "./create-admin.module";


// WEBPACK FOOTER //
// ./src/app/superadmin/create-admin/index.ts